import { render, staticRenderFns } from "./TaskCommentTreeView.vue?vue&type=template&id=7dc871a3&"
import script from "./TaskCommentTreeView.vue?vue&type=script&lang=js&"
export * from "./TaskCommentTreeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc871a3')) {
      api.createRecord('7dc871a3', component.options)
    } else {
      api.reload('7dc871a3', component.options)
    }
    module.hot.accept("./TaskCommentTreeView.vue?vue&type=template&id=7dc871a3&", function () {
      api.rerender('7dc871a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/TaskCommentTreeView.vue"
export default component.exports